<template>
  <div :style="style" class="py-2">
    <flickity v-if="hasTimes" :options="options" class="px-4">
      <div v-for="(el, key) in times" :key="key" class="w-1/3 px-1">
        <span
          class="flex bg-gray-50 justify-center h-10 items-center rounded border select-none cursor-pointer hover:time"
          @click="$emit('on:form', el)"
        >
          <sameday-time :settings="settings" :params="el" />
        </span>
      </div>
    </flickity>
    <div
      v-else
      class="flex bg-gray-50 justify-center p-2 items-center rounded border text-sm text-gray-500"
    >
      {{ noAvailMessage }}
    </div>
  </div>
</template>

<script>
import Flickity from "vue-flickity";
import SamedayTime from "@/components/Sameday/SamedayTime.vue";

const options = {
  prevNextButtons: true,
  pageDots: false,
  wrapAround: false,
  draggable: false,
  contain: true,
  freeScroll: true,
  cellAlign: "left",
  groupCells: 3,
};

export default {
  components: {
    Flickity,
    SamedayTime,
  },
  props: {
    settings: {
      type: Object,
      default: () => {},
    },
    times: {
      type: [Array, Object],
      default: () => [],
    },
  },
  computed: {
    hasTimes() {
      const isArray = Array.isArray(this.times);
      if (isArray && this.times.length > 0) return true;
      if (!isArray && Object.keys(this.times).length > 0) return true;
      return false;
    },
    options() {
      if (!this.hasTimes) return;
      if (this.times.length > 3) return options;
      return { ...options, prevNextButtons: false };
    },
    style() {
      const colors = this.$store.state.config?.colors;
      return {
        "--border-color": colors?.primaryOptionColor || "#51B44F",
        "--bg-color": colors?.secondaryOptionColor || "#D4F3BB",
      };
    },
    noAvailMessage() {
      if (!this.settings) return;
      if (!this.settings?.no_avail_message) return "No availabilities";
      return this.settings.no_avail_message;
    },
  },
};
</script>

<style scoped>
.hover\:time:hover {
  background-color: var(--bg-color);
  border-color: var(--border-color);
}
.flickity-enabled /deep/ .flickity-button.flickity-prev-next-button {
  width: 22px;
  height: 40px;
  margin-top: 3px;
  border-radius: 0;
  background-color: transparent;
}
.flickity-enabled /deep/ .flickity-button.flickity-prev-next-button.previous {
  left: 0;
}
.flickity-enabled /deep/ .flickity-button.flickity-prev-next-button.next {
  right: 0;
}
</style>
